var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.OfflineOnly),expression:"OfflineOnly"}],staticClass:"offline-badge fixed p10 bg-cl-th-error cl-white center-xs"},[_vm._v(" "+_vm._s(_vm.$t('You are offline. Some features might not be available.'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }